import React, { useState } from 'react';
import styled from 'styled-components';

import Layout from './components/Layout';
import SearchDrugs from './components/SearchDrugs';
import NavBarContainer from '../../../containers/common/NavBarContainer';


const MenuContainer = styled.div`
    max-width: 1400px;
    margin: auto;
`;

const ManageDrugsContainer = () => {
    const [totalRXCUI, setTotalRXCUI] = useState(0);
    return (
        <main className='usa-layout-docs usa-section gi-main-section'>
            <MenuContainer className="grid-container gi-grid-container grid-row">
                <NavBarContainer navBarClass="ticket-mgmt-top-nav grid-col-12" />
            </MenuContainer>
            <Layout totalRXCUI={totalRXCUI}>
                <SearchDrugs setTotalRXCUI={setTotalRXCUI} />
            </Layout>
        </main>
    );
};

export default ManageDrugsContainer;